import Axios from "axios";
import { BaseService } from "./BaseService";
import { EmpresaFact, EmpresaFactCertificado, EmpresaFactCertificadoFiltro, EmpresaFactLogo, EmpresaFactLogo2, EmpresaResponsableOcultar, EmpresaResponsableOcultarFiltro } from "@/model/EmpresaFact";

BaseService.loadAxios();

const RESOURCE_NAME = "/empresafact";

export class EmpresaFactService {
    public static async getEmpresasFactAsync() {
        return await Axios.get(RESOURCE_NAME + "/empresas");
    }

    public static async getClientesAsync() {
        return await Axios.get(RESOURCE_NAME + "/clientes");
    }

    public static async getEmpresaFactLoadTreeAsync() {
        return await Axios.get(RESOURCE_NAME + '/loadTree');
    }

    public static async getEmpresaFactByIdAsync(id) {
        return await Axios.get(RESOURCE_NAME + '/' + id);
    }

    public static async grabarClienteAsync(empresaFact: EmpresaFact) {
        return await Axios.post(RESOURCE_NAME + '/cliente', empresaFact);
        //return await Axios.post("Prueba");
    }

    public static async actualizarClienteAsync(empresaFact: EmpresaFact) {
        return await Axios.put(RESOURCE_NAME + '/cliente', empresaFact);
        //return await Axios.put("Prueba");
    }

    public static async grabarEmpresaFactAsync(empresaFact: EmpresaFact) {
        return await Axios.post(RESOURCE_NAME, empresaFact);
        //return await Axios.post("Prueba");
    }

    public static async actualizarEmpresaFactAsync(empresaFact: EmpresaFact) {
        return await Axios.put(RESOURCE_NAME, empresaFact);
        //return await Axios.put("Prueba");
    }

    public static async borrarEmpresaFact(id: number) {
        //return await Axios.delete("Prueba");
        return await Axios.delete(`${RESOURCE_NAME}/${id}`);
    }
    
    public static async grabarLogoFactura(logo: EmpresaFactLogo2) {
        return await Axios.post(`${RESOURCE_NAME}/logo`, logo);
    }

    public static async actualizarLogoFactura(logo: EmpresaFactLogo2, id: string) {
        return await Axios.put(`${RESOURCE_NAME}/logo/${id}`, logo);
    }

    public static async cargarLogoFactura(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/logo/${id}`);
    }

    public static async cargarLogos(logo: EmpresaFactLogo) {
        return await Axios.post(`${RESOURCE_NAME}/logos`, logo);
    }
    
    public static async grabarLogo(logo: EmpresaFactLogo) {
        return await Axios.post(`${RESOURCE_NAME}/logo/grabar`, logo);
    }

    public static async borrarLogo(id: string) {
        return await Axios.delete(`${RESOURCE_NAME}/logo/borrar/${id}`);
    }

    //#region "Certificados Empresa"
    public static async cargarCertificados(filtro: EmpresaFactCertificadoFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/certificados`, filtro);
    }
    
    public static async grabarCertificados(certificado: EmpresaFactCertificado) {
        return await Axios.post(`${RESOURCE_NAME}/certificado/grabar`, certificado);
    }

    public static async descargarCertificado(item: EmpresaFactCertificadoFiltro) {
        return await Axios.put(`${RESOURCE_NAME}/certificado/descargar`,item);
    }
    
    //#endregion
    
    //#region "Empresa Ocultar"
    public static async getEmpresasOcultarAsync(filtro: EmpresaResponsableOcultarFiltro) {
        return await Axios.post(RESOURCE_NAME+ "/empresas/ocultas", filtro);
    }
 
    public static async ocultarEmpresasResponsableAsync(item: EmpresaResponsableOcultar){
        return await Axios.post(RESOURCE_NAME + "/ocultar/empresas", item);
    }

    //#endregion
    

}